import { vinSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const tripsBuilderTripsByVinPayloadSchema = z.object({
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  vin: vinSchema,
});

export type TripsBuilderTripsByVinPayload = z.infer<
  typeof tripsBuilderTripsByVinPayloadSchema
>;
